import { L10n } from '@syncfusion/ej2-base';

export const loadTranslations = (lang: string) => {
  const langMap: Record<string, string> = {
    en: 'en',
    nl: 'nl',
    sr: 'sr',
  };

  if (!langMap[lang]) {
    return Promise.resolve();
  }

  return import(`./${langMap[lang]}.json`).then((module) => {
    L10n.load({
      [langMap[lang]]: module,
    });
  });
};
